import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_ALBUM').plugin(axiosPlugin);

let fetchUserAlbumAction = redux.fetchActionGetOne();

let createUserAlbumAction = redux.fetchActionCreate();

let updateUserAlbumAction = redux.fetchActionUpdate();

let deleteMediaAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const fetchUserAlbum = (userId, albumId, query = {}) => fetchUserAlbumAction(`/users/${userId}/albums/${albumId}?${queryString.stringify(query)}`);
export const createUserAlbum = (userId, data) => createUserAlbumAction(`/users/${userId}/albums`, data);
export const updateUserAlbum = (userId, albumId, data) => updateUserAlbumAction(`/users/${userId}/albums/${albumId}`, data);
export const deleteUserAlbum = (userId, albumId = {}) => deleteMediaAction(`/users/${userId}/albums/${albumId}`);
export const resetUserAlbum = () => redux.actions.reset();

export const userAlbum = redux.reducer();